<form [formGroup]="form" (ngSubmit)="saveLivraisons()" novalidate>

  <div class="d-flex justify-content-between mg-b-10">
    <strong>
      <yo-help class="mg-r-15" lang="fr" [file]="pathFile" [dialogMsgSupplier]="help()" [width]="800"></yo-help>
      <span class="mg-r-5">Planning des livraisons fournisseur</span>
    </strong>
    <span>
      <yo-button
        tooltip="Enregistrer"
        type="submit"
        iconClass="fas fa-save"
        [theme]="ButtonThemeEnum.SAVE"
        [disabled]="!gds.canModify(uniteDeProduction) || !canWrite()"></yo-button>
    </span>
  </div>

  <yo-dx-tab-menu
    [items]="navUpLivraisonDx"
    [selectedItem]="activeItemDx"
    width="30%"
    marginBottom="24px"
    (itemClick)="goToTabLivraison($event)">
  </yo-dx-tab-menu>

  <fieldset>

    @if (displayNavFournisseurs()) {
      <div class="d-flex flex-row">

        <!--JOURS-->
        <div class="mg-r-15">
          <h3 class="first">Jours de livraison</h3>
          <dx-list
            [items]="joursSemaineList"
            displayExpr="viewValue"
            keyExpr="value"
            selectionMode="all"
            selectAllMode="allPages"
            [showSelectionControls]="true"
            [searchEnabled]="true"
            searchExpr="viewValue"
            searchMode="contains"
            [selectedItemKeys]="selectedJourSemaineKeyList"
            (onSelectionChanged)="onChangeJoursSemaine($event)"
            [ngClass]="{'yo-list-readonly': !gds.canModify(uniteDeProduction) || !canWrite()}"
            [width]="250"
            [height]="250">
          </dx-list>
          @if (formJoursLivraisonUDP.controls['joursSemaineUDP'].dirty && formJoursLivraisonUDP.controls['joursSemaineUDP'].hasError('required')) {
            <div class="error">La sélection d'un ou plusieurs jours(s) de livraison est obligatoire.</div>
          }
        </div>

        <!--SECTEUR-->
        <div class="mg-r-15">
            <h3 class="first">Secteurs</h3>
            <dx-list
              [items]="secteurList"
              displayExpr="libelle"
              keyExpr="id"
              selectionMode="all"
              selectAllMode="allPages"
              [showSelectionControls]="true"
              [searchEnabled]="true"
              searchExpr="libelle"
              searchMode="contains"
              [selectedItemKeys]="selectedSecteurKeyList"
              (onSelectionChanged)="onChangeSecteurs($event)"
              [ngClass]="{'yo-list-readonly': !gds.canModify(uniteDeProduction) || !canWrite()}"
              [width]="250"
              [height]="300">
            </dx-list>
            @if (formJoursLivraisonUDP.controls['secteursUDP']?.dirty && formJoursLivraisonUDP.controls['secteursUDP']?.hasError('required')) {
              <div class="error">La sélection d'un ou plusieurs secteur(s) est obligatoire.</div>
            }
          </div>

        <!--Filiales Fournisseurs-->
        <div class="mg-r-15">
          <h3 class="first">
            Filiales Fournisseurs
            @if (!utils.isCollectionNullOrEmpty(secteurFournisseurList)) {
              <span class="mg-l-5">({{getNbSecteursFournisseursActifs()}}/{{secteurFournisseurList.length}})</span>
            }
          </h3>
          <dx-list
            [items]="secteurFournisseurList"
            keyExpr="id"
            selectionMode="all"
            selectAllMode="allPages"
            [showSelectionControls]="true"
            [searchEnabled]="true"
            searchExpr="fournisseurLibelle"
            searchMode="contains"
            [selectedItemKeys]="selectedSecteurFournisseurKeyList"
            (onSelectionChanged)="addToAffectationFournisseurs($event)"
            [ngClass]="{'yo-list-readonly': !gds.canModify(uniteDeProduction) || !canWrite()}"
            [width]="450"
            [height]="620">
            <div *dxTemplate="let secteurFournisseur of 'item'">
              <div [title]="tooltipSecteurFournisseur(secteurFournisseur)" style="white-space: nowrap;">
                <span>{{secteurFournisseur.fournisseurLibelle}}</span>
                <span class="font-10">({{secteurFournisseur.secteur.libelle}})</span>
                @if (!udpSecteurFournisseurSvc.secteurFournisseurActif(secteurFournisseur)) {
                  &nbsp;<i class="fas fa-exclamation-triangle danger-color space"></i>
                }
              </div>
            </div>
          </dx-list>
        </div>

      </div>
    } @else {
      <!--AFFECTATIONS-->
      <yo-up-livraisons-affectation
        [affectationsSupplier]="affectationsSupplier"
        [canWrite]="canWrite()">
      </yo-up-livraisons-affectation>
    }

  </fieldset>

  <div class="row">
    <div class="col-md-12 font-12">
      <p>
        🗣️<em> N'oubliez pas d'enregistrer.</em>
      </p>
    </div>
  </div>

</form>
